module.exports = __webpack_public_path__ + "img/truck-full.9eddae73.svg";